import React from 'react';
import { cx } from '@emotion/css';
import Image from 'next/image';

export const AreasWeCover = ({ styles }: any) => {
  return (
    <section className={styles.areas}>
      <div className={cx(styles.container, styles.root)}>
        <h3 className={cx(styles.site_title, styles.h3)}>Areas we cover</h3>
        <div className={styles.area_map}>
          <div className={styles.area_map_wrap}>
            <Image
              src="/images/services/heat-and-gas/map.png"
              alt="Areas We Cover"
              width={600}
              height={600}
              className={styles.area_map_img}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
